import React, {useState, useEffect, Suspense} from "react";
import ReactGA from 'react-ga';
import ReactDOM from "react-dom";
import {BrowserRouter as Router,Switch,Route} from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import ErrorBoundary from './components/ErrorBoundary';

import API from './data/api.component.js';

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

const App = React.lazy(() => import( /* webpackChunkName: "App" */ "./App"));
const AboutUs = React.lazy(() => import( /* webpackChunkName: "AboutUs" */ "./AboutUs"));
const ContactUs = React.lazy(() => import( /* webpackChunkName: "ContactUs" */ "./ContactUs"));
const HostEvent = React.lazy(() => import( /* webpackChunkName: "HostEvent" */ "./HostEvent"));
const TrailsideTips = React.lazy(() => import( /* webpackChunkName: "TrailsideTips" */ "./TrailsideTips"));

function useFetchEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await API.getNewProvider();
        setEvents(response?.body?.result ?? []);
      } catch (err) {
        console.error('Failed to fetch events:', err);
        setError('Unable to load events. Please try again later.');
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  return [events, loading, error];
}

function PageTracker() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return null;
}

function Root() {
  const [events, loading, error] = useFetchEvents();
  const newData = !loading && !error ? events : [];

  return (
    <ErrorBoundary>
    <Router>
        <PageTracker />
        <Suspense fallback = {
          <div className = "loading" / >
        } >
          <Switch>
            <Route exact path = "/" >
              <App data={newData} loading={loading} error={error} />

            </Route > 
            <Route exact path = "/about-us" >
              <AboutUs />
            </Route> 
            <Route exact path = "/contact-us" >
              <ContactUs />
            </Route> 
            <Route exact path = "/host-an-event" >
              <HostEvent />
            </Route> 
            <Route exact path = "/trailside-tips" >
              <TrailsideTips />
            </Route> 
          </Switch > 
        </Suspense> 
    </Router>
    </ErrorBoundary>
  )
}

ReactDOM.render( < Root / > , document.getElementById('root'));
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();